// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__QCeH2","link_download":"styles_link_download__jryIY","text_time":"styles_text_time__mdM9K"};